import {Part} from "../part";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PartMenuType} from "../../../visComponents/constants";
import {LayoutType, ShowerComboTubType} from "../constants";
import { showerTubComboThumbnail, custom60in30X8Shower } from '../../../bvComponent/core/assets';

import BathTubLiner from "../subparts/showerTubCombo/bathtubLiner";
import ReplacementTub from "../subparts/showerTubCombo/replacementTub";
import WalkInTub from "../subparts/showerTubCombo/walkInTub";
import JettedTub from "../subparts/showerTubCombo/jettedTub";
import WallConfiguration from "../subparts/showerTubCombo/wallConfiguration";
import {fixDbFeatureProperties} from "../../../../misc/helpers";

export class ShowerTubCombo extends Part {
  static id = 'Shower Tub Combo';

  constructor() {
    super(true, false, PartMenuType.Complex);

    this.showerTubComboIsActive = false;  // param needed to check if shower is still active or not
    this.menuType = PartMenuType.Complex;
    this.partThumbnail = showerTubComboThumbnail;
    this.partName = 'Shower Tub Combo';
    this.translateId = "visualizer.bathroom.shower_tub_combo";
    this.relatedItems = [];
    this.wallConfiguration = null;
    this.bathTubLiner = null;
    this.replacementTub = null;
    this.walkInTub = null;
    this.jettedTub = null;

    // Kohler hardcode, they don't have bathtub_liner
    this.bottomTub = ShowerComboTubType.replacement_tub;
    this.leftShowerWallType = 'Pony';
    this.showerComboSize = '60in';

  }

  load(dbFeature) {
    let relatedItemName = "",
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Bathtub Liner":
        relatedItemName = "bathTubLiner";
        RelatedItemClass = BathTubLiner;
        break;
      case "Replacement Tub":
        relatedItemName = "replacementTub";
        RelatedItemClass = ReplacementTub;
        break;
      case "Walk In Tub":
        relatedItemName = "walkInTub";
        RelatedItemClass = WalkInTub;
        break;
      case "Jetted Tub":
        relatedItemName = "jettedTub";
        RelatedItemClass = JettedTub;
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return true
    }
    return false
  }

  setSpecificRules() {
    if (!this.wallConfiguration) {
      this.wallConfiguration = new WallConfiguration(true);
      this.wallConfiguration.counts = {
        allLayoutFeaturesCount: 0,
        largeLayoutFeaturesCount: 0,
        smallLayoutFeaturesCount: 0
      };
      this.relatedItems.unshift(this.wallConfiguration);
      this.wallConfiguration.getParent = () => this;
    }
    Object.keys(LayoutType).forEach(layoutType => {
      this.wallConfiguration.featuresList[layoutType] = [
        ShowerTubCombo.createCustomWallConfiguration(
          custom60in30X8Shower,
          "Full Wall 60in",
          "30X8",
          "60in",
          {
            "RoomLayout": [layoutType],
            "ShowerSize": ['60in'],
            "CountertopSize": ["20in", "24in", "30in", "36in", "48in", "60in", "72in"],
          },
          this,
          100001
        ),
      ];
      this.wallConfiguration.counts[layoutType.toLowerCase() + "LayoutFeaturesCount"]++;
    });
  }

  static createCustomWallConfiguration(customThumbnail, name, leftShowerWallType, showerComboSize, metaData, parent, id) {
    const conf = new WallConfiguration();
    conf.partName = name;
    conf.showerBodyId = name.toLowerCase().replace(/ /gi, "-");
    conf.dbFeature = {};
    conf.featureName = name;
    conf.groupName = "Wall Configuration";
    conf.showerComboSize = showerComboSize;
    // conf.parent = parent;
    conf.getParent = () => parent.wallConfiguration;
    conf.metaData = metaData;
    conf.leftShowerWallType = leftShowerWallType;
    conf.customThumbnail = customThumbnail;
    conf.dbFeature = fixDbFeatureProperties({
      metaData,
      id,
      unlocked: true
    });
    return conf;
  }

  setLayers(layout, placeholdersNeeded) {

    if (!this.showerTubComboIsActive) {
      return null
    }

    let res = [];
    this.getRelatedItems().forEach(relatedItem => {
      relatedItem.setLayers(layout);
      (placeholdersNeeded && !relatedItem.placeholderChanged && relatedItem.placeholderFeature)
        ? relatedItem.placeholderFeature.layer.addTo(res)
        : relatedItem.activeFeature ? relatedItem.activeFeature.layer.addTo(res) : null;
    });

    return res.length ? res : null;
  }

  subParts() {

    let subParts = [
      ...this.getRelatedItems().filter(item => item.visible).map(_ => new DesignNavigationItem(_.partName, _)),
      ...this.layout.parts.Shower.subParts().filter(subPart => {
        return (subPart.text === "Fixture")
          || (subPart.text === "Shower Head")
          || (subPart.text === "Shower Walls")
          || (subPart.text === "Shower Walls Accent")
          || (subPart.text === "Shower Door")
          || (subPart.text === "Handle")
          || (subPart.text === "Pony Wall")
          || (subPart.text === "Pony Wall Cap")
          || (subPart.text === "Pony Wall Glass")
      })
    ];

    if (this.bottomTub === ShowerComboTubType.walk_in_tub) {
      subParts = subParts.filter(subPart => {
        return subPart.part.partId !== "shower_door" && subPart.part.partId !== "shower_door_handle" && subPart.part.partId !== "shower_fixture"
      })
    }

    return subParts
  }

  getShowerRelatedItems() {
    return this.layout.parts.Shower.getRelatedItems().filter(relItem => {
      return (relItem.partId === "shower_fixture")
        || (relItem.partId === "shower_head")
        || (relItem.partId === "shower_interior_wall")
        || (relItem.partId === "shower_wall_accent")
        || (relItem.partId === "shower_door")
        || (relItem.partId === "shower_door_handle")
        || (relItem.partId === "pony_wall")
        || (relItem.partId === "pony_wall_cap")
        || (relItem.partId === "pony_wall_glass")
    })
  }

  setShowerTubCombo() {
    this.showerTubComboIsActive = true;
    if (this.layout.type === LayoutType.Small) {
      const showerParent = this.layout.parts.Shower;
      if (showerParent.showerBody && showerParent.showerBody.disabled) { // switch on all Shower features
        showerParent.showerBody.disabled = false;
        showerParent.showerBody.disabledClick();
        this.showerTubComboIsActive = true;
      }
    }
  }

  isSubTypeWithItems() {
    return false
  }

  handleSubPartClick() {}

  setZIndex(zIndexes) {
    if (!this.showerTubComboIsActive) {
      return null
    }

    if(zIndexes)
      this.relatedItems.forEach(_ => _.setZIndex(zIndexes));
  }

  setActiveTub(bottomTub) {
    this.bottomTub = bottomTub;
  }

  showerSize() {
    return this.showerComboSize
  }

  showerDimensions() {
    return this.leftShowerWallType
  }

  setShowerSize(leftShowerWallType, showerComboSize) {
    this.leftShowerWallType = leftShowerWallType;
    this.showerComboSize = showerComboSize;
  }

  setDefault() {
    // this.relatedItems.forEach(relatedItem => relatedItem.setDefault(layout));
  }

}
